<script setup lang="ts">
import { VBadge } from 'vuetify/components';

withDefaults(
    defineProps<{
        dot?: VBadge['$props']['dot'];
        color?: VBadge['$props']['color'];
        inline?: VBadge['$props']['inline'];
        content?: VBadge['$props']['content'];
    }>(),
    { dot: false, inline: false },
);

defineOptions({ inheritAttrs: false });
</script>

<template>
    <VBadge
        v-bind="$attrs"
        :dot="dot"
        :color="color"
        :inline="inline"
        :content="content"
        class="b-badge"
    >
        <slot />
    </VBadge>
</template>
